import React from 'react';
import { withRouter } from 'react-router-dom';
import { useViewport } from 'components/templates/viewportProvider';
import RenderSEO from 'components/atoms/renderSEO';
import thankYouImage from 'assets/images/Thank You-1.jpg';
import thankYouMobileImage from 'assets/images/Thank You-1-mob.jpg';
import { CallToAction } from 'components/atoms/callToAction';
import { RouteUtil } from 'utils/RouteUtil';
import { RouteNames } from 'router';

const PaymentCancellation = props => {
  const { isMobile } = useViewport();
  const metaTagSEO = {
    metaTitle: 'Total Environment | Apartments | Villas | India',
    metaDescription:
      'With an innate drive to create enhanced living experience for people, Total Environment designs apartments, penthouses and villas that people actually want to live in. From live music to handcrafted furniture to fine craft beer, we leave our mark of excellence everywhere. To know more about our homes and handcrafted experiences, call + 91 99000 78000.',
    metaKeywords: '',
  };

  const logoClass = isMobile ? 'thank-you-page-mobile' : 'thank-you-page';

  const handleClick = () => {
    RouteUtil.setRouteChange(props, RouteNames.musicEvents);
  };

  const handleLogoClick = () => {
    RouteUtil.setRouteChange(props, '/');
  };

  return (
    <>
      <RenderSEO metaTags={metaTagSEO} currentRouteName={'homes'} />
      <div className={`section error-page ${isMobile ? 'mobile' : ''}`}>
        {isMobile ? (
          <img
            src={thankYouMobileImage}
            alt={'Background'}
            className={'background'}
          />
        ) : (
          <img
            src={thankYouImage}
            alt={'Background'}
            className={'background'}
          />
        )}
        <div className={'section-header'}>
          <div
            className={`logo-container ${logoClass}`}
            onClick={handleLogoClick}
          >
            <strong>Total</strong>Environment
          </div>
        </div>
        <div className={'section-container'}>
          {isMobile ? (
            <h2 className={'thank-you-heading'} style={{ textAlign: 'center' }}>
              Payment Cancelled.
            </h2>
          ) : (
            <h1 className={'thank-you-heading'} style={{ textAlign: 'center' }}>
              Payment Cancelled.
            </h1>
          )}
          <h3>Payment Cancelled! Try Again.</h3>
          <CallToAction
            text={'Go back to events'}
            onClick={handleClick}
            mode={'transparent'}
            type={'link'}
            isMobile={true}
          />
        </div>
      </div>
    </>
  );
};

export default withRouter(PaymentCancellation);
